<script>
export default {
	props: ['currentZone', 'ProductPage'],
	hookZone: ['after--images', 'bottom-inside', 'bottom'],
	showHook(currentZone, ProductPage) {
		return ProductPage.product.info.templateKey == 'infoTabs'
	},
	computed: {
		showDescriptionAndAttrs() {
			return (
				(this.$b.d && this.currentZone == 'after--images') ||
				(this.$b.mt && this.currentZone == 'bottom-inside')
			)
		},
		showInfoTabs() {
			return this.currentZone == 'bottom'
		},
		templateData() {
			return this.ProductPage.product.info.templateData
		},
		attrs() {
			return this.ProductPage.product.attrs || []
		},
	},
}
</script>

<template>
	<div>
		<template v-if="showDescriptionAndAttrs">
			<v-divider />
			<DpcHook :items="ProductPage.hooksData['hooks-product-description-top']" />
			<ProductPage-Description :templateData="templateData" :product="ProductPage.product" class="pa-3" />
			<ProductPage-Attributes :attributes="attrs" class="pa-3" />
			<DpcHook :items="ProductPage.hooksData['hooks-product-description-bottom']" />
		</template>
		<ProductPage-InfoTabs v-if="showInfoTabs" :items="templateData.descriptionItems" />
	</div>
</template>

